import { render, staticRenderFns } from "./SingleAutobuyerBox.vue?vue&type=template&id=2888ded7&scoped=true&"
import script from "./SingleAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./SingleAutobuyerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888ded7",
  null
  
)

export default component.exports